import React from "react";
import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import GitHub from "../assets/github.png";
import Tailwind from "../assets/tailwind.png";

const Skills = () => {
  return (
    <div name="skills">
      {/* container */}
      <div
        name="container"
        className="max-w-[1000px] h-screen px-4 mx-auto text-gray-300 "
      >
        <div>
          <p className="text-4xl font-bold inline-block border-b-4 border-[#008037]  mx-auto text-center">
            Experience
          </p>
          <p className="py-4">
            //This are the technologies I've been working with
          </p>
        </div>
        {/* inner container for imgs */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-center py-8     w-full ">
          {/* img self container */}
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={HTML} alt="html_icon" className="w-20  mx-auto" />
            <p>HTML</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={CSS} alt="css_icon" className="w-20  mx-auto" />
            <p>CSS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={JavaScript} alt="js_icon" className="w-20  mx-auto" />
            <p>JavaScript</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={GitHub} alt="gitgub_icon" className="w-20  mx-auto" />
            <p>GitHub</p>
          </div>

          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={Tailwind} alt="tailwind_icon" className="w-20  mx-auto" />
            <p>Tailwind CSS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 rounded pt-2">
            <img src={ReactImg} alt="reactjs_icon" className="w-20  mx-auto" />
            <p>React</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
